var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_c('router-link',{attrs:{"to":"/attributions"}},[_vm._v("Info & Attributions")]),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact me")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }